import { createContext, useContext } from "react";
export const useArticleHeaderContext = () => {
    const context = useContext(ArticleHeaderContext);
    if (context === undefined) {
        throw new Error("Component is not a child of ArticleHeader");
    }
    return context;
};
export const ArticleHeaderContext = createContext(undefined);
